module.exports = __webpack_public_path__ + "img/face.2e980534.png";